import { useMutation } from "react-query";

import useApiHelper from "../../services/useApiHelper";
import { SendTestEmail } from "../../models/emailTemplates/EmailTemplate";

export function useEmailTemplateMutations(
  agencyId: string,
  emailTemplateId: string
) {
  const { post } = useApiHelper();

  const sendTest = useMutation(
    (data: SendTestEmail) =>
      post(`/emailtemplate/${emailTemplateId}/send-test/${agencyId}`, data)
  );


  return {
    sendTest,
  };
}
